document.addEventListener("DOMContentLoaded", () => {
  // In ~ CM 切换
  $(document).off('click', '.incm-container').on('click', '.incm-container', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var _that = $(this);
    if(_that.hasClass(`cm-active`)){
      _that.parents(`.table-section`).find(`.size-table-wrap table td`).each(function(){
        let tempAttr = $(this).attr(`data-inch`);
        $(this).html(tempAttr);
      });
      _that.removeClass(`cm-active`);
      _that.attr('aria-label', _that.attr('data-cm-tips'));
      _that.attr('aria-pressed', 'false');
    }else{
      _that.parents(`.table-section`).find(`.size-table-wrap table td`).each(function(){
        let tempAttr = $(this).attr(`data-cm`);
        $(this).html(tempAttr);
      });
      _that.addClass(`cm-active`);
      _that.attr('aria-label', _that.attr('data-inch-tips'));
      _that.attr('aria-pressed', 'true');
    }
  });
  $(document).off('keydown', '.incm-container').on('keydown', '.incm-container', function(e) {
    if(e.key == 'Enter' || e.key == ' '){
      e.preventDefault();
      e.stopPropagation();
      $(this).click();
    }
  });
  $(document).off('mouseenter', '.size-table-wrap table td').on('mouseenter', '.size-table-wrap table td', function(e){
    e.preventDefault();
    e.stopPropagation();
    let cellIndex = e.currentTarget.cellIndex;
    $(this).addClass(`selected-table-element`);
    if($(this).prevAll(`th`).length > 0) {
      $(this).prevAll(`th`).addClass(`cross-section-header`);
      $(this).prevAll(`td`).addClass(`cross-section-data`);
    };
    $(this).parents(`table`).find("thead th").eq(cellIndex).addClass(`cross-section-header`);
    $(this).parent().prevAll(`tr`).each(function(){
      $(this).children(`th`).eq(cellIndex).addClass(`cross-section-header`);
      let th_length = $(this).children(`th`).length;
      th_length > 0 ? $(this).children(`td`).eq(cellIndex - th_length).addClass(`cross-section-data`) : $(this).children(`td`).eq(cellIndex).addClass(`cross-section-data`);
    });
  });
  $(document).off('mouseleave', '.size-table-wrap table td').on('mouseleave', '.size-table-wrap table td', function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass(`selected-table-element`);
    $(`.size-table-wrap table td`).removeClass(`cross-section-data`);
    $(`.size-table-wrap table th`).removeClass(`cross-section-header`);
  });

  // Toggle Item Show/Hide
  $(document).off('click', '.size-guide-item .item-title').on('click', '.size-guide-item .item-title', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if($(this).siblings(`.item-description`).is(":hidden")){
      $(this).find(`.toggle-btn`).addClass(`active`).attr("aria-expanded","true");
    }
    else{
      $(this).find(`.toggle-btn`).removeClass(`active`).attr("aria-expanded","false");
    }
    $(this).siblings(".item-description").slideToggle();
  });
  $(document).off('keydown', '.toggle-btn').on('keydown', '.toggle-btn', function(e) {
    if(e.key == 'Enter' || e.key == ' '){
      e.preventDefault();
      e.stopPropagation();
      $(this).parents(".item-title").click();           
    }
  });
});
